var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24641 0.559448C4.10641 0.559448 0.753906 3.91945 0.753906 8.05945C0.753906 12.1994 4.10641 15.5594 8.24641 15.5594C12.3939 15.5594 15.7539 12.1994 15.7539 8.05945C15.7539 3.91945 12.3939 0.559448 8.24641 0.559448ZM8.25391 14.0594C4.93891 14.0594 2.25391 11.3744 2.25391 8.05945C2.25391 4.74445 4.93891 2.05945 8.25391 2.05945C11.5689 2.05945 14.2539 4.74445 14.2539 8.05945C14.2539 11.3744 11.5689 14.0594 8.25391 14.0594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62891 4.30945H7.50391V8.80945L11.4414 11.1719L12.0039 10.2494L8.62891 8.24695V4.30945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryClock);
export default __webpack_public_path__ + "static/media/summary-clock.0a8ebc7cebad14a948abba86c1c2bf9f.svg";
export { ForwardRef as ReactComponent };